<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">会員サイト利⽤登録本解除</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <h2 class="mb-5">
        会員サイトご利⽤登録を解除しました。
      </h2>
      <p class="mb-3 text-center">ご利⽤ありがとうございました。</p>
    </div>
    <div class="my-5 text-center">
      <router-link to="/login" class="btn d-inline-block">このページを閉じる</router-link>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
</style>
